import { useEffect, useRef, useState } from "react";
import mermaid from "mermaid";

let initialized = false;
function initMermaid() {
  if (initialized) return;
  mermaid.initialize({
    startOnLoad: false,
    securityLevel: "loose",
    theme: "base",
    fontFamily: "Arial, Helvetica, sans-serif",
    flowchart: { htmlLabels: true, useMaxWidth: true, padding: 12, nodeSpacing: 50, rankSpacing: 60 },
    themeVariables: {
      primaryColor: "#f3efff",
      primaryBorderColor: "#5D28C7",
      primaryTextColor: "#1a1a1a",
      lineColor: "#7c4dde",
      secondaryColor: "#ffffff",
      tertiaryColor: "#faf8ff",
      noteBkgColor: "#fef6e7",
      noteBorderColor: "#e0a23a",
      actorBkg: "#f3efff",
      actorBorder: "#5D28C7",
      fontSize: "14px",
    },
  });
  initialized = true;
}

let counter = 0;

export const Mermaid = ({ chart, className = "" }) => {
  const [svg, setSvg] = useState("");
  const idRef = useRef(`mmd-${++counter}`);

  useEffect(() => {
    let active = true;
    initMermaid();
    mermaid
      .render(idRef.current, chart)
      .then(({ svg }) => active && setSvg(svg))
      .catch((e) => active && setSvg(`<p class="text-sm text-red-500">Diagram error: ${String(e).slice(0, 120)}</p>`));
    return () => {
      active = false;
    };
  }, [chart]);

  return (
    <div
      className={`mermaid-wrap overflow-x-auto rounded-md border border-black/5 bg-white p-5 [&_svg]:mx-auto [&_svg]:h-auto [&_svg]:max-w-full ${className}`}
      data-testid="mermaid-diagram"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};
